import React from 'react';
import { 
  Building, 
  Server, 
  Users, 
  BarChart4, 
  Code, 
  ArrowRight, 
  Share2,
  QrCode,
  MessageSquare,
  Gift,
  CreditCard,
  WalletCards
} from 'lucide-react';
import FeatureCard from './features/FeatureCard';
import FeatureList from './features/FeatureList';
import PricingButton from './features/PricingButton';
import IntegrationsShowcase from './sections/IntegrationsShowcase';

const SaasFeatures: React.FC = () => {
  return (
    <>
      <section className="py-12 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-primary-blue mb-2">Program Features</h2>
            <p className="text-lg text-gray-600">Everything you need to manage and track your referrals</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <FeatureCard
              icon={Users}
              title="Simple Referral Signup"
              description="One-step referral process makes it easy for users to connect and sign up in seconds."
            >
              <FeatureList
                icon={Code}
                items={[
                  "Share via email, link, or QR code",
                  "Embed with website code integration",
                  "Send referrals via SMS text"
                ]}
              />
            </FeatureCard>
            
            <FeatureCard
              icon={Share2}
              title="Multi-Channel Sharing"
              description="Share your referral link across all popular platforms with just a few clicks."
            >
              <div className="flex flex-wrap gap-2 mt-2">
                <span className="px-3 py-1 bg-primary-blue/10 text-primary-blue rounded-full text-sm">WhatsApp</span>
                <span className="px-3 py-1 bg-primary-blue/10 text-primary-blue rounded-full text-sm">Facebook</span>
                <span className="px-3 py-1 bg-primary-blue/10 text-primary-blue rounded-full text-sm">Instagram</span>
                <span className="px-3 py-1 bg-primary-blue/10 text-primary-blue rounded-full text-sm">X</span>
              </div>
            </FeatureCard>
            
            <FeatureCard
              icon={Gift}
              title="Flexible Redemption"
              description="Multiple ways to reward your referrers based on points collected."
            >
              <FeatureList
                icon={CreditCard}
                items={[
                  "Buy reward gift cards instantly",
                  "Offer point-based rewards",
                  "Pay referrers via ACH direct deposit"
                ]}
              />
            </FeatureCard>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <FeatureCard
              icon={Building}
              title="Multi-Tenant Platform"
              description="With your reseller plan, you receive a platform that allows you to sell to 300 customers. Add more platform capacity by upgrading to an additional 300 to an infinite number."
            >
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <FeatureList
                    icon={ArrowRight}
                    items={[
                      "Dedicated dashboard",
                      "Support system",
                      "Custom branding",
                      "Unique domain"
                    ]}
                  />
                </div>
                <div>
                  <FeatureList
                    icon={ArrowRight}
                    items={[
                      "Easy plan upgrades",
                      "Client management",
                      "Payment tracking",
                      "Analytics reports"
                    ]}
                  />
                </div>
              </div>
            </FeatureCard>
            
            <FeatureCard
              icon={Server}
              title="Secure Infrastructure"
              description="Enterprise-grade security with data isolation between tenants and regular backups."
            >
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <FeatureList
                    icon={ArrowRight}
                    items={[
                      "Password protection and resets",
                      "IP address login monitoring",
                      "Fraud and order security"
                    ]}
                  />
                </div>
                <div>
                  <FeatureList
                    icon={ArrowRight}
                    items={[
                      "2FA login available",
                      "No repeat passwords",
                      "Captcha enabled"
                    ]}
                  />
                </div>
              </div>
            </FeatureCard>
            
            <FeatureCard
              icon={QrCode}
              title="Advanced Tracking"
              description="Track every referral link click with detailed analytics about origins and conversions."
            />
            
            <FeatureCard
              icon={BarChart4}
              title="Monthly Reports"
              description="Get detailed monthly reports summarizing your referral activity and earned points."
            />
          </div>

          <PricingButton />
        </div>
      </section>

      <IntegrationsShowcase />
    </>
  );
};

export default SaasFeatures;
